// @flow

import { type Receipt } from '@tectonics/prs/receipts';
import { type AllowedLocalTaxCodeSubstrings, type LocalTax } from '@tectonics/prs/money';

export function getLocalTaxFromCodeSubstring(receipt: Receipt, taxCodeSubstring: AllowedLocalTaxCodeSubstrings): ?LocalTax {
  return receipt.local_taxes.find(tax => tax.code.includes(taxCodeSubstring));
}
